import { NutritionistRequestDetail } from './../../shared/models/request-nutritionist-detail.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RequestNutritionistService {

  private baseURL = environment.baseURL;
  constructor(private http: HttpClient) { }

  createNutritionistDetail(detail: NutritionistRequestDetail) {
    return this.http.post<NutritionistRequestDetail>(`${this.baseURL}/nutritionists-request`, detail);
  }

  getNutritionistDetail(requestID: number) {
    return this.http.get<NutritionistRequestDetail>(`${this.baseURL}/nutritionists-request/${requestID}`);
  }

  updateNutritionistDetail(requestID: number, detail: NutritionistRequestDetail) {
    return this.http.put<NutritionistRequestDetail>(`${this.baseURL}/nutritionists-request/${requestID}`, detail);
  }

  deleteNutritionistDetail(requestID: number) {
    return this.http.delete<NutritionistRequestDetail>(`${this.baseURL}/nutritionists-request/${requestID}`);
  }

}
